export default "__VITE_ASSET__D9eG6u33__"